var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { class: { "grey--text": _vm.disabled }, attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        { staticClass: "card-bg-2 headline" },
        [
          _c(
            "v-flex",
            {
              staticStyle: {
                flex: "0 0 130px",
                "align-items": "baseline",
                display: "flex",
              },
            },
            [
              _vm._v("\n      Stations\n      "),
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "open-on-hover": "",
                    "open-delay": 400,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            "v-icon",
                            _vm._g(
                              {
                                staticClass: "clickable ml-2",
                                attrs: { color: "primary" },
                                on: {
                                  click: function ($event) {
                                    _vm.showHelp = true
                                  },
                                },
                              },
                              on
                            ),
                            [_vm._v("\n            info_outline\n          ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.showHelp,
                    callback: function ($$v) {
                      _vm.showHelp = $$v
                    },
                    expression: "showHelp",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c("v-card-text", [
                        _vm._v(
                          " The stations shown contain at least one of the selected time series. "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "pa-0" },
        [
          _c("SelectContinuousStationComponents", {
            ref: "selectStationComponents",
            attrs: {
              search: _vm.search,
              timeSeriesStations: _vm.timeSeriesStations,
              selection: _vm.selection,
              disabled: _vm.disabled,
              filterToggle: _vm.filterToggle,
              filterToggles: _vm.filterToggles,
              selectionCount: _vm.stationsLength,
              stations: _vm.stations,
            },
            on: {
              loading: function ($event) {
                return _vm.$emit("loading", $event)
              },
              selected: _vm.onSelectedStationComponents,
              isSearching: function ($event) {
                _vm.issearching = $event
              },
              missingStationIds: function ($event) {
                return _vm.$emit("missingStationIds", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }